<template>
  <section>
    <!--工具条-->
    <div>
      <el-form :inline="true">
        <el-form-item label="客户名称">
          <el-input v-model="filters.clientName" placeholder="客户名称"></el-input>
        </el-form-item>
        <el-form-item label="工程名称">
          <el-input v-model="filters.projectName" placeholder="工程名称"></el-input>
        </el-form-item>
        <el-form-item label="强度等级">
          <el-input v-model="filters.gradeName" placeholder="强度等级"></el-input>
        </el-form-item>
        <el-form-item label="特殊材料">
          <el-input v-model="filters.specMtlName" placeholder="特殊材料"></el-input>
        </el-form-item>
        <el-form-item label="浇筑方式">
          <el-input v-model="filters.pouringMethodName" placeholder="浇筑方式"></el-input>
        </el-form-item>
        <el-form-item label="施工部位">
          <el-input v-model="filters.projectPart" placeholder="施工部位"></el-input>
        </el-form-item>
        <el-form-item label="施工地址">
          <el-input v-model="filters.proejctAddress" placeholder="施工地址"></el-input>
        </el-form-item>
        <el-form-item label="发货时间">
          <el-date-picker type="datetime" placeholder="开始日期" v-model="filters.startTime"
            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
          <el-date-picker type="datetime" placeholder="结束日期" v-model="filters.endTime"
            value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getReportList(1)">查询</el-button>
          <el-button type="primary" @click="downReport">导出</el-button>
        </el-form-item>
      </el-form>

    </div>
    <!--列表-->
    <el-table :data="dmList" highlight-current-row v-loading="listLoading" style="width: 100%" border show-summary
      :summary-method="getSummaries">
      <el-table-column prop="ProductionTime" label="生产时间" :formatter="formatTimeYMD"></el-table-column>
     
      <el-table-column prop="ClientName" label="客户名称"></el-table-column>
      <el-table-column prop="ProjectName" label="工程名称"></el-table-column>
      <el-table-column prop="ProjectPart" label="施工部位"></el-table-column>
      <el-table-column prop="ProejctAddress" label="施工地址"></el-table-column>
      <el-table-column prop="PouringMethodName" label="浇筑方式"></el-table-column>
      <el-table-column prop="PumpingDriverName" label="泵车司机" width="80"></el-table-column>
      <el-table-column prop="GradeName" label="强度等级"></el-table-column>
      <el-table-column prop="SpecMtlName" label="特殊材料"></el-table-column>
      <el-table-column prop="TQuantity" label="生产方量"></el-table-column>
      <el-table-column prop="QuantityDelivery" label="发货方量"></el-table-column>
      <el-table-column prop="VehiclesTotal" label="车次"></el-table-column>
      <el-table-column prop="Remark" label="联系电话"></el-table-column>
    </el-table>
    <el-pagination layout="total, sizes, prev, pager, next, jumper" :page-size="filters.intPageSize" :total="total"
      @current-change="handleCurrentChange" @size-change="handleSizeChange" class="my-pagination"></el-pagination>
  </section>
</template>

<script>
//引入Material.js的所有export的对象,并起别名为api,通过api.***访问成员
import * as api from "../../api/command";
import Toolbar from "../../components/Toolbar";
import util from "../../../util/date";
export default {
  components: { Toolbar },
  data() {
    return {
      currentRow: null,
      filters: {
        startTime: "",
        endTime: "",
        clientName: "",
        projectName: "",
        gradeName: "",
        specMtlName: "",
        pouringMethodName: "",
        projectPart: "",
        proejctAddress: "",
        page: 1,
        intPageSize: 20,
      },
      total: 0,
      dmList: [],
      sumData: {},
      listLoading: false,
    };
  },
  computed: {},
  methods: {
    getSummaries(param) {
      var sums = [];
      sums[0] = "合计";
      sums[1] = "";
      sums[2] = "";
      sums[3] = "";
      sums[4] = "";
      sums[5] = "";
      sums[6] = "";
      sums[7] = "";
      sums[8] = "";
      sums[9] = this.sumData.TQuantity;
      sums[10] = this.sumData.QuantityDelivery;
      sums[11] = this.sumData.VehiclesTotal;
      sums[12] = "";

      return sums;
    },
    //工具条绑定事件方法
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.filters.page = val;
      this.getReportList();
    },
    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.filters.intPageSize = size;
      this.getReportList(1);
    },
    //获取原材料消耗
    getReportList(optype) {
      if (optype == 1) {
        this.filters.page = 1;
      }
      let para = this.filters;
      this.listLoading = true;
      this.dmList = [];
      api
        .GetProdOutMasterGroup(para)
        .then((res) => {
          if (res && res.data && res.data.response && res.data.response.data)
            this.dmList = res.data.response.data;
          this.sumData = res.data.responsesum;
          this.total = res.data.response.dataCount;
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    //导出原材料消耗
    downReport() {
      let para = this.filters;
      var sheetName = "生产统计表";
      api.DownProdOutMasterGroup(para, sheetName).then((res) => { });
    },
    formatTimeYMD(row, column) {
      return !row.ProductionTime || row.ProductionTime == ""
        ? ""
        : util.formatDate.format(new Date(row.ProductionTime), "yyyy/MM/dd");
    }, formatDate(date) {
      function padZero(num) {
        return num < 10 ? '0' + num : num;
      }
      var year = date.getFullYear();
      var month = padZero(date.getMonth() + 1); // 月份是从0开始的
      var day = padZero(date.getDate());
      var hours = padZero(date.getHours());
      var minutes = padZero(date.getMinutes());
      var seconds = padZero(date.getSeconds());

      return year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds;
    },
  },
  mounted() {
    let pastDate = new Date(new Date().setHours(0, 0, 0, 0));
    pastDate.setDate(pastDate.getDate()); //num正数为后一天，负数为前一天
    this.filters.startTime = this.formatDate(pastDate);

    let endDate = new Date(new Date().setHours(23, 59, 59, 0));
    endDate.setDate(endDate.getDate()); //num正数为后一天，负数为前一天
    this.filters.endTime = this.formatDate(endDate);
    this.getReportList();
  },
};
</script>

<style lang="less" scoped>
.input-select {
  width: 300px;
}
</style>
